/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_FloorInputs */

const cs_filter_floor = /** @type {(inputs: Filter_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patro`)
};

const en_filter_floor = /** @type {(inputs: Filter_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor`)
};

/**
* | output |
* | --- |
* | "Floor" |
*
* @param {Filter_FloorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_floor = /** @type {((inputs?: Filter_FloorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_FloorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_floor(inputs)
	return cs_filter_floor(inputs)
});